import { useContext } from "react";
import { EmptyStateContext } from "../providers";

export function useEmptyState() {
  return useContext(EmptyStateContext);
}
